import { Component, OnInit, HostListener, Query } from '@angular/core';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { MasterService } from '@app/utility/master.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '@app/auth.service';
import { Subscription } from 'rxjs';
import { timer } from 'rxjs/observable/timer'
import { environment } from '@env/environment';

declare var $: any
enum CustomerType {
  Company = 1,
  Person = 2
};

@Component({
  selector: 'app-ticket-list',
  templateUrl: './ticket-list.component.html',
  styleUrls: ['./ticket-list.component.scss']
})

export class TicketListComponent implements OnInit {
  AcceptExtension: any;
  MaxTotalSizeMB: number
  TotalFileSize: number = 0;
  Ticket: any;
  Contact: any;
  Type: CustomerType;
  CompanyTypeList: any;
  PersonTypeList: any;
  DocumentList: any;
  Profile: any;
  Role: any;
  Editable: boolean = true;

  DataSource1: any = [];
  DataSource2: any = [];
  FileList: any = [];

  OTPRefCode: string = "";
  ElapseTime: number = 0;
  TotalTime: number = 0;
  SubScr: Subscription;
  WaitTime: number;
  SubScr2: Subscription;

  masterStatus: any

  constructor(
    private Util: UtilService,
    private Api: ApiService,
    private MasterService: MasterService,
    private Auth: AuthService,
    private FB: FormBuilder
  ) {
  }

  // @HostListener('window:keyup', ['$event'])
  // handleKeyboardEvent(event: KeyboardEvent) {
  //   if (event.key == "Enter") {
  //     //alert(event.target.id);
  //     let t: any = event.target;
  //     if (t.id == "Search1")
  //       this.CreateTable1();
  //     else if (t.id == "Search2")
  //       this.CreateTable2();
  //   }
  // }

  async ngOnInit() {
    this.Profile = await this.Auth.GetProfile(localStorage.getItem("AgentBank_Profile"));
    this.Role = await this.Auth.GetRole(this.Profile[0]["dpa_roleid"]);
    this.Role = this.Role[0];
    this.masterStatus = await this.Api.get("master", "approvalStatus")

    if (this.Role.dpa_access_approve) {
      $('#SuperFilter').removeClass("hidden");
      $('#OfficerFilter').addClass("hidden");
      $('#Table2Title').html('รายการที่อนุมัติแล้ว');
    }
    else {
      $('#SuperFilter').addClass("hidden");
      $('#OfficerFilter').removeClass("hidden");
      $('#Table2Title').html('รายการที่รออนุมัติ / อนุมัติแล้ว');
    }

    await this.CreateTable1();
    await this.CreateTable2();
    $('#dlgDetails').on('shown.bs.modal', function () {
      $('#txtTicketID').trigger('focus')
    })

    let thisTs = this;

    this.AcceptExtension = environment.AcceptUploadFileExtension;
    this.MaxTotalSizeMB = await this.MasterService.GetMaxUploadFileSize();

    var TableDocs = $('#TableDocs');
    TableDocs.on('click', 'tbody tr td [role=view]', function () {
      thisTs.ViewDoc($(this).attr('url'), $(this).attr('filename'));
    });

    TableDocs.on('click', 'tbody tr td [role=delete]', function () {
      thisTs.DeleteDoc($(this).attr('filename'), $(this).attr('annotationid'));
    });
  }

  async onSearch1Change(){
    if($("#Search1").val().length == 13){
      await this.CreateTable1();
    }
  }

  async CreateTable1() {
    let thisTs = this;
    // this.Util.ShowWaiting(true);

    if (this.Role.dpa_access_approve) {
      let SearchFirstName = $("#SearchFirstName").val();
      let SearchLastName = $("#SearchLastName").val();
      let SearchIdCard = $("#SearchIdCard").val();
      let SearchPassport = $("#SearchPassport").val();
      let QueryString = "approvalstatuscode=02";
      if (SearchFirstName != "")
        QueryString += "&firstname=" + SearchFirstName;
      if (SearchLastName != "")
        QueryString += "&lastname=" + SearchLastName;
      if (SearchIdCard != "")
        QueryString += "&idcard=" + SearchIdCard;
      if (SearchPassport != "")
        QueryString += "&passportid=" + SearchPassport;        
      this.DataSource1 = await this.Api.get("crmservice", "searchApprovalTicket", QueryString);
    }
    else {
      let SearchText = $("#Search1").val();
      if (SearchText == null || SearchText == "") {
        this.DataSource1 = [];
      }
      else {
        this.DataSource1 = await this.Api.get("crmservice", "searchApprovalTicket", "ticketno=" + SearchText + "&approvalstatuscode=01");
      }
    }

    var Table1 = $('#Table1').DataTable();
    Table1.destroy();

    Table1 = $('#Table1').DataTable({
      "data": thisTs.DataSource1,
      "columns": [
        { "data": "dpa_name" },
        {
          "data": "dpa_contactid",
          "render": function (data: any, type: any, row: any) {
            return row.dpa_authorizedperson == null ? row.dpa_contactidname : row.dpa_authorizedperson;
          }
        },
        {
          "data": "dpa_contactidname",
          "render": function (data: any, type: any, row: any) {
            return row.dpa_authorizedperson == null ? "" : row.dpa_contactidname;
          }
        },
        {
          "data": "dpa_originalsource",
          "render": function (data: any, type: any, row: any) {
            if (row.dpa_originalsource == 1)
              return "Customer Portal";
            else
              return "Agent Bank";
          }
        },
        {
          "data": "dpa_approvalstatusidname",
          "render": function (data: any, type: any, row: any) {
            return row.dpa_approvalstatusidname;
          }
        },
        {
          "data": "dpa_submitdate",
          "render": function (data: any, type: any, row: any) {
            if (row.dpa_submitdate != null) {
              var d = new Date(row.dpa_submitdate);
              return '<span class="sr-only">' + d.getFullYear().toString() + (d.getMonth() + 1 < 10 ? "0" : "") + (d.getMonth() + 1).toString() + (d.getDate() < 10 ? "0" : "") + d.getDate().toString() + '</span>' +
                thisTs.Util.ConvertToBE(d.getDate().toString() + "/" + (d.getMonth() + 1).toString() + "/" + d.getFullYear().toString());
            }
            else
              return "";
          }
        }
      ],
      "language": {
        "lengthMenu": "แสดง _MENU_ รายการ/หน้า",
        "zeroRecords": "ไม่มีข้อมูล",
        "search": "ค้นหา:",
        "info": "แสดงรายการที่ _START_ - _END_ จากทั้งหมด _TOTAL_ รายการ",
        "infoEmpty": "ไม่มีข้อมูล",
        "infoFiltered": "(ค้นหาจากทั้งหมด _MAX_ รายการ)",
        "paginate": {
          "previous": "<",
          "first": "<<",
          "next": ">",
          "last": ">>"
        }
      },
      "ordering": true,
      "searching": false,
      "order": [[5, "asc"]]
    });

    $('#Table1 tbody').on('click', 'tr', function () {
      var data = Table1.row(this).data();
      if (data == null)
        return;
      thisTs.ShowDetails(data);
      $('#dlgDetails').modal();
    });
    this.Util.ShowWaiting(false);
  }

  async onSearch2Change(){
    if($("#Search2").val().length == 13){
      this.CreateTable2()
    }
  }

  async CreateTable2() {
    // this.Util.ShowWaiting(true);
    let thisTs = this;
    let SearchText = $("#Search2").val();
    if (SearchText == null || SearchText == "") {
      // if (this.Role.dpa_access_approve) {
      //   let data: any = await this.Api.get("crmservice", "searchApprovalTicket", "approvalstatuscode=03");
      //   this.DataSource2 = data;
      //   data = await this.Api.get("crmservice", "searchApprovalTicket", "approvalstatuscode=05");
      //   data.forEach((a: any) => {
      //     this.DataSource2.push(a);
      //   });
      // }
      // else {
        this.DataSource2 = [];
      // }
    }
    else {
      if (this.Role.dpa_access_approve) {
        let data: any = await this.Api.get("crmservice", "searchApprovalTicket", "ticketno=" + SearchText + "&approvalstatuscode=03");
        this.DataSource2 = data;
        data = await this.Api.get("crmservice", "searchApprovalTicket", "ticketno=" + SearchText + "&approvalstatuscode=05");
        data.forEach((a: any) => {
          this.DataSource2.push(a);
        });
      }
      else {
        this.DataSource2 = await this.Api.get("crmservice", "searchApprovalTicket", "ticketno=" + SearchText);
        if (this.DataSource2.length > 0) {
          let data = this.DataSource2;
          data.forEach((a: any) => {
            if (a.dpa_approvalstatuscode == '01')
              this.DataSource2 = this.DataSource2.filter((b: any) => b.dpa_approvalticketid != a.dpa_approvalticketid);
          });
        }
      }
    }

    var Table2 = $('#Table2').DataTable();
    Table2.destroy();
    Table2 = $('#Table2').DataTable({
      "data": thisTs.DataSource2,
      "columns": [
        { "data": "dpa_name" },
        {
          "data": "dpa_contactid",
          "render": function (data: any, type: any, row: any) {
            return row.dpa_authorizedperson == null ? row.dpa_contactidname : row.dpa_authorizedperson;
          }
        },
        {
          "data": "dpa_contactidname",
          "render": function (data: any, type: any, row: any) {
            return row.dpa_authorizedperson == null ? "" : row.dpa_contactidname;
          }
        },
        {
          "data": "dpa_originalsource",
          "render": function (data: any, type: any, row: any) {
            if (row.dpa_originalsource == 1)
              return "Customer Portal";
            else
              return "Agent Bank";
          }
        },
        {
          "data": "dpa_approvalstatusidname",
          "render": function (data: any, type: any, row: any) {
            return row.dpa_approvalstatusidname
          }
        },
        {
          "data": "dpa_submitdate",
          "render": function (data: any, type: any, row: any) {
            if (row.dpa_submitdate != null) {
              var d = new Date(row.dpa_submitdate);
              return '<span class="sr-only">' + d.getFullYear().toString() + (d.getMonth() + 1 < 10 ? "0" : "") + (d.getMonth() + 1).toString() + (d.getDate() < 10 ? "0" : "") + d.getDate().toString() + '</span>' +
                thisTs.Util.ConvertToBE(d.getDate().toString() + "/" + (d.getMonth() + 1).toString() + "/" + d.getFullYear().toString());
            }
            else
              return "";
          }
        }
      ],
      "language": {
        "lengthMenu": "แสดง _MENU_ รายการ/หน้า",
        "zeroRecords": "ไม่มีข้อมูล",
        "search": "ค้นหา:",
        "info": "แสดงรายการที่ _START_ - _END_ จากทั้งหมด _TOTAL_ รายการ",
        "infoEmpty": "ไม่มีข้อมูล",
        "infoFiltered": "(ค้นหาจากทั้งหมด _MAX_ รายการ)",
        "paginate": {
          "previous": "<",
          "first": "<<",
          "next": ">",
          "last": ">>"
        }
      },
      "ordering": true,
      "searching": false,
      "order": [[5, "asc"]]
    });

    $('#Table2 tbody').on('click', 'tr', function () {
      var data = Table2.row(this).data();
      if (data == null)
        return;
      thisTs.ShowDetails(data);
      $('#dlgDetails').modal();
    });
    this.Util.ShowWaiting(false);
  }

  async ShowDetails(Rec: any) {
    this.Util.ShowWaiting(true);
    this.Ticket = Rec;
    let thisTs = this;
    this.CompanyTypeList = JSON.parse(localStorage.getItem("companyType"));
    this.PersonTypeList = JSON.parse(localStorage.getItem("personalType"));

    $('#TicketNo').val(this.Ticket.dpa_name);
    if (this.Ticket.dpa_personaltypeid != null && this.Ticket.dpa_personaltypeid != "" &&
      this.PersonTypeList.filter((a: any) => a.dpa_personaltypeid == this.Ticket.dpa_personaltypeid) != null) {
      this.Type = CustomerType.Person;
      $('#CustomerType').val(this.Ticket.dpa_personaltypeidname);
      $('#divPerson').removeClass("hidden");
      $('#divCompany').addClass("hidden");

      if (this.Ticket.dpa_personaltypeidname.includes("ต่างชาติ")) {
        $('#IDCardNo').html("เลขพาสปอร์ต");
        $('#CitizenID2').val(this.Ticket.dpa_passport);
      }
      else {
        $('#IDCardNo').html("เลขบัตรประชาชน");
        $('#CitizenID2').val(this.Ticket.dpa_idcard);
      }
      let Name = this.Ticket.dpa_contactidname.split(" ");
      $('#FirstName2').val(Name[0]);
      $('#LastName2').val(Name[1]);
    }
    else {
      this.Type = CustomerType.Company;
      $('#CustomerType').val(this.Ticket.dpa_companytypeidname);
      $('#divPerson').addClass("hidden");
      $('#divCompany').removeClass("hidden");

      $('#CompanyName').val(this.Ticket.dpa_contactidname);
      $('#RegistrationID').val(this.Ticket.dpa_registrationid);
      if (this.Ticket.dpa_authorizedperson == null || this.Ticket.dpa_authorizedperson == "") {
        $('#FirstName1').val("");
        $('#LastName1').val("");
      }
      else {
        let Name = this.Ticket.dpa_authorizedperson.split(" ");
        $('#FirstName1').val(Name[0]);
        $('#LastName1').val(Name[1]);
      }
      $("#CitizenID1").val(this.Ticket.dpa_authorizedperson_idcard);
    }
    $("#Remark").val(this.Ticket.dpa_remark);

    this.Editable = true;
    $("#divButtonRecreate").addClass("hidden");
    $("#divRemark").attr("disabled", "disabled");
    if (this.Ticket.dpa_approvalstatuscode == '01') {
      $("#PhoneNo").text(this.Ticket.telephone1 == null ? "" : this.Ticket.telephone1)
      $("#OTP").val("");
      $("#divOTP").removeClass("hidden");
      $("#divDocList").attr("disabled", "disabled");
      $("#divUpload").attr("disabled", "disabled");
      $("#divUpload").removeClass("hidden");
      $("#divFiles").attr("disabled", "disabled");
      $("#divButtons").attr("disabled", "disabled");
      $("#divButtons").removeClass("hidden");
      // await this.RequestOTP();
    }
    else {
      $("#divOTP").addClass("hidden");
      $("#divDocList").removeAttr("disabled");
      $("#divUpload").removeClass("hidden");
      $("#divUpload").removeAttr("disabled");
      $("#divFiles").removeAttr("disabled");
      $("#divButtons").removeAttr("disabled");
      $("#divButtons").removeClass("hidden");
      if (this.Ticket.dpa_approvalstatuscode == '02') {
        // if (this.Role.dpa_access_approve) {
        $("#divUpload").addClass("hidden");
        $("#divDocList").attr("disabled", "disabled");
        this.Editable = false;
        // }
        // else
        if (!this.Role.dpa_access_approve) {
          $("#divButtons").addClass("hidden");
        }
        else {
          $("#divRemark").removeAttr("disabled");
        }
      }
    }
    if (this.Ticket.dpa_approvalstatuscode == '03' || this.Ticket.dpa_approvalstatuscode == '05' || this.Ticket.dpa_approvalstatuscode == '06') {
      $("#divDocList").attr("disabled", "disabled");
      $("#divUpload").addClass("hidden");
      // $("#divRemark").attr("disabled", "disabled");
      //if (this.Ticket.dpa_code == 3 || this.Ticket.dpa_code == 5)
      //$("#divButtons").attr("disabled", "disabled");
      $("#divButtons").addClass("hidden");
      this.Editable = false;
      if (this.Ticket.dpa_approvalstatuscode == '06' && (this.Role.dpa_access_approve == null || this.Role.dpa_access_approve == false)) {
        $("#divButtonRecreate").removeClass("hidden");
        $("#btnRecreate").html("อัปโหลดเอกสาร");
      }
    }

    this.Ticket.attachfilelist.forEach((a: any) => {
      var Decoded = atob(a.documentbody);
      a.filesize = Decoded.length;
      a.url = "data:" + a.mimetype + ";base64," + a.documentbody;
    });
    this.FileList = this.Ticket.attachfilelist;
    this.CreateTableFile();
    this.CreateDocumentList();
    $('.docCheck').on("change", function (e: any) {
      thisTs.SelectDocument(e.target);
    });
    this.Util.ShowWaiting(false);
  }

  CreateDocumentList() {
    var DocList: any;
    $("#divDocList").empty();
    if (this.Type == CustomerType.Person) {
      if (this.Ticket.dpa_personaltypeid == null) {
        return;
      }
      DocList = this.PersonTypeList.filter((a: any) => a.dpa_personaltypeid == this.Ticket.dpa_personaltypeid)[0].dpa_documentgrouplist;
    }
    else {
      if (this.Ticket.dpa_companytypeid == null) {
        return;
      }
      DocList = this.CompanyTypeList.filter((a: any) => a.dpa_companytypeid == this.Ticket.dpa_companytypeid)[0].dpa_documentgrouplist;
    }
    this.DocumentList = [];
    if (this.Ticket.dpa_documentchecklist != null && this.Ticket.dpa_documentchecklist != "") {
      let Selected = this.Ticket.dpa_documentchecklist.split("|");
      for (var i = 0; i < Selected.length; i++) {
        this.DocumentList.push({
          "dpa_documentid": Selected[i]
        });
      }
    }
    
    let DivContent = '<br />';
    let SeqNo = 1;
    let Checked = "";
    // DocList.forEach((DocGroup: any) => {
    //   DocGroup["dpa_documentlist"].forEach((Doc: any) => {
    //     Checked = this.DocumentList.length == 0 ? "" : this.Ticket.dpa_documentchecklist.includes(Doc.dpa_documentid) ? " checked" : "";
    //     DivContent += '<label class="checktable">';
    //     DivContent += ' <input type="checkbox" class="docCheck" value="' + Doc.dpa_documentid + '"' + Checked + '><span class="checkmark"></span>';
    //     DivContent += ' <label>' + SeqNo + '. ' + Doc.dpa_name + '</label>';
    //     DivContent += '</label>';
    //     SeqNo++;
    //   });
    // });
    DocList.forEach((DocGroup: any) => {
      Checked = this.DocumentList.length == 0 ? "" : this.Ticket.dpa_documentchecklist.includes(DocGroup.dpa_documentgroupid) ? " checked" : "";
      DivContent += '<label class="checktable">';
      DivContent += ' <input type="checkbox" class="docCheck" value="' + DocGroup.dpa_documentgroupid + '"' + Checked + '><span class="checkmark"></span>';
      DivContent += ' <label>' + SeqNo + '. ' + DocGroup.dpa_name + '</label>';
      DivContent += '</label>';
      SeqNo++;
    });
    $("#divDocList").append(DivContent);
  }

  SelectDocument(target: any) {
    if (target.checked) {
      if (this.DocumentList == null || this.DocumentList == undefined)
        this.DocumentList = [];
      this.DocumentList.push({
        "dpa_documentid": target.value,
      });
    }
    else {
      this.DocumentList = this.DocumentList.filter((a: any) => a.dpa_documentid != target.value);
    }
  }

  CreateTableFile() {
    let thisTs = this;
    var TableDocs = $('#TableDocs').DataTable({
      "paging": false,
      "bFilter": false,
      "info": false,
      "data": thisTs.FileList,
      "columns": [
        { "data": "filename", "class": "text-center" },
        { "data": "filename" },
        {
          "data": "filesize",
          "render": function (data: any, type: any, row: any) {
            if (row.filesize / 1024 / 1024 < 1) {
              return Math.floor(row.filesize / 1024) + ' KB';
            }
            else {
              return (Math.round(row.filesize / 1024 / 1024 * 100 + Number.EPSILON) / 100) + ' MB';
            }
          },
          "class": "text-right"
        },
        {
          "data": null,
          "render": function (data: any, type: any, row: any) {
            return '<i class="fa fa-eye editicon cursorpointer" role="view" url="' + row.url + '" filename="' + row.filename + '" title="View"></i>' +
              (thisTs.Editable ? '<i class="fa fa-times deleteicon cursorpointer" role="delete" filename="' + row.filename + '" annotationid="' + row.annotationid + '" title="Delete"></i>' : '');
          },
          "class": "col-btn-2 text-center"
        }
      ],
      "language": {
        "zeroRecords": "ยังไม่ได้อัปโหลดไฟล์"
      }
    });

    TableDocs.on('order.dt search.dt', function () {
      TableDocs.column(0, { search: 'applied', order: 'applied' }).nodes().each(function (cell: any, i: any) {
        cell.innerHTML = i + 1;
      });
    }).destroy().draw();
  }

  async BackToHome(ReloadTable: any) {
    //if (ReloadTable) {
    $('#Search1').val('');
    $('#Search2').val('');
    let Table1 = $('#Table1').DataTable();
    let Table2 = $('#Table2').DataTable();
    Table1.destroy();
    Table2.destroy();
    await this.CreateTable1();
    await this.CreateTable2();
    //}
    setTimeout(() => {
      $('#btnCloseDlg').click();
    }, 200);
  }

  async ViewDoc(Url: any, FileName: any) {
    if (Url == "") {
      this.Util.ErrorDialog('ไม่พบไฟล์ที่เลือก');
      return;
    }
    window.open(this.Util.CreateBlobUrl(Url), "_blank");

    // $("#FileNameTitle").html(FileName);
    // $("#ViewDocFrame").attr("src", this.Util.CreateBlobUrl(Url));
    // $('#dlgFile').modal();

    // var link = document.createElement('a');
    // link.href = Url;
    // link.target = "_blank";
    // link.download = FileName;
    // link.click();
    // console.log("click!");
  }

  async DeleteDoc(FileName: any, AnnotationID: any) {
    let thisTs = this;
    await this.Util.ConfirmDialog("คุณต้องการลบไฟล์เอกสารแนบใช่หรือไม่?");
    $("#btnMainConfirm").off('click');
    $("#btnMainConfirm").click(async function () {
      if (AnnotationID != null && AnnotationID != "" && AnnotationID != "null") {
        //await thisTs.Api.delete("crmservice", "delAnnotation/" + AnnotationID);
        let DelObj: any = {
          annotationid: AnnotationID
        };
        await thisTs.Api.post("crmservice", "delAnnotation2", DelObj);
      }
      thisTs.FileList.forEach((item: any, index: any) => {
        if (item["filename"] === FileName)
          thisTs.FileList.splice(index, 1);
      });
      thisTs.TotalFileSize = 0;
      thisTs.Ticket.attachfilelist.forEach((a: any) => {
        var Decoded = atob(a.documentbody);
        a.filesize = Decoded.length;
        thisTs.TotalFileSize += a.filesize;
      });
      thisTs.Ticket.dpa_attachsizing = thisTs.TotalFileSize;
      thisTs.CreateTableFile();
    });
  }

  async FileSelect(File: any) {
    if (File.length == 0)
      return;
    var FileName = File[0]["name"];
    var FileExtension = FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length);

    if (!this.AcceptExtension.includes(FileExtension.toLowerCase())) {
      this.Util.ErrorDialog('รองรับเฉพาะไฟล์ ' + this.AcceptExtension);
      $('#fileAttach').val('');
      return;
    }

    var TotalFileSize: number = File[0]["size"];
    this.FileList.forEach((a: any) => {
      TotalFileSize += +a["filesize"];
    });
    if (TotalFileSize / 1024 / 1024 > this.MaxTotalSizeMB) {
      this.Util.ErrorDialog('ขนาดไฟล์รวมทั้งหมดต้องไม่เกิน ' + this.MaxTotalSizeMB + " MB");
      $('#fileAttach').val('');
      return;
    }
    if (this.FileList != null) {
      if (this.FileList.filter((a: any) => a.filename == File[0].name).length > 0) {
        this.Util.WarningDialog("ชื่อไฟล์ซ้ำกับไฟล์ที่อัปโหลดแล้ว");
        return;
      }
    }

    var FR = new FileReader();
    var FileContent: any;
    var MimeType: any;
    let thisTs = this;
    FR.onload = (e) => {
      var t: any = e.target;
      FileContent = t.result;
      MimeType = FileContent.substring(FileContent.indexOf(":") + 1, FileContent.indexOf(";"));
      var FileContent2 = FileContent.substring(FileContent.indexOf(",") + 1, FileContent.length);

      if (thisTs.FileList == null || thisTs.FileList == undefined)
        thisTs.FileList = [];
      thisTs.FileList.push({
        "annotationid": null,
        "filename": File[0].name,
        "documentbody": FileContent2,
        "mimetype": MimeType,
        "filesize": File[0]["size"],
        "url": FileContent
      });
      $('#fileAttach').val('');
      // $('#txtFileName').val('');
      thisTs.CreateTableFile();
    };
    FR.readAsDataURL(File[0]);
    // $('#txtFileName').val(File[0]["name"]);
  }

  async UploadFile() {
    var FileInput = $('#fileAttach')[0]["files"];
    if (FileInput.length == 0) {
      this.Util.ErrorDialog('กรุณาเลือกไฟล์');
      return;
    }
    if (this.FileList != null) {
      if (this.FileList.filter((a: any) => a.filename == FileInput[0].name).length > 0) {
        this.Util.WarningDialog("ชื่อไฟล์ซ้ำกับไฟล์ที่อัปโหลดแล้ว");
        return;
      }
    }

    var File = new FileReader();
    var FileContent: any;
    var MimeType: any;
    let thisTs = this;
    File.onload = async (e) => {
      var t: any = e.target;
      FileContent = t.result;
      MimeType = FileContent.substring(FileContent.indexOf(":") + 1, FileContent.indexOf(";"));
      var FileContent2 = FileContent.substring(FileContent.indexOf(",") + 1, FileContent.length);

      if (thisTs.FileList == null || thisTs.FileList == undefined)
        thisTs.FileList = [];
      thisTs.FileList.push({
        "annotationid": null,
        "filename": FileInput[0].name,
        "documentbody": FileContent2,
        "mimetype": MimeType,
        "filesize": FileInput[0]["size"],
        "url": FileContent
      });
      $('#fileAttach').val('');
      $('#txtFileName').val('');
      if (thisTs.Ticket.dpa_approvalstatuscode == '02') {
        thisTs.Ticket.attachfilelist = thisTs.FileList;
        await thisTs.Api.post("crmservice", "approvalticket", thisTs.Ticket);
        let T: any = await thisTs.Api.get("crmservice", "searchapprovalticket", "ticketno=" + thisTs.Ticket.dpa_name);
        thisTs.Ticket = T[0];
        thisTs.Ticket.attachfilelist.forEach((a: any) => {
          var Decoded = atob(a.documentbody);
          a.filesize = Decoded.length;
          a.url = "data:" + a.mimetype + ";base64," + a.documentbody;
        });
        thisTs.FileList = thisTs.Ticket.attachfilelist;
      }
      thisTs.CreateTableFile();
    };
    File.readAsDataURL(FileInput[0]);
  }

  async UpdateStatus(Approve: any) {
    if (this.FileList.length == 0) {
      this.Util.WarningDialog("กรุณาอัปโหลดไฟล์เอกสาร");
      return;
    }

    var DocGroup: any;
    if (this.Type == CustomerType.Company) {
      DocGroup = this.CompanyTypeList.filter((a: any) => a.dpa_companytypeid == this.Ticket.dpa_companytypeid)[0].dpa_documentgrouplist;
    }
    else {
      DocGroup = this.PersonTypeList.filter((a: any) => a.dpa_personaltypeid == this.Ticket.dpa_personaltypeid)[0].dpa_documentgrouplist;
    }

    this.Ticket.dpa_submitdate = this.Ticket.dpa_submitdate;
    this.Ticket.dpa_documentchecklist = "";
    this.DocumentList.forEach((a: any) => {
      this.Ticket.dpa_documentchecklist += (this.Ticket.dpa_documentchecklist == "" ? "" : "|") + a.dpa_documentid;
    });

    let thisTs = this;
    try {
      if (Approve) {
        let IsValid = await this.Util.ValidateSelectedDocument(this.DocumentList, DocGroup);
        if (!IsValid)
          return;

        await this.Util.ConfirmDialog("ยืนยันอนุมัติรายการ?");
        $("#btnMainConfirm").off('click');
        $("#btnMainConfirm").click(async function () {
          //thisTs.Ticket.dpa_code = 2;
          thisTs.Ticket.attachfilelist = thisTs.FileList;
          thisTs.TotalFileSize = 0;
          thisTs.Ticket.attachfilelist.forEach((a: any) => {
            var Decoded = atob(a.documentbody);
            a.filesize = Decoded.length;
            thisTs.TotalFileSize += a.filesize;
            a.url = "";
          });
          thisTs.Ticket.dpa_attachsizing = thisTs.TotalFileSize;
          thisTs.Ticket.dpa_approvalstatuscode = thisTs.Role.dpa_access_approve ? '03' : '02';
          thisTs.Ticket.dpa_remark = $("#Remark").val();
          
          thisTs.Ticket.dpa_approvalstatusid = thisTs.GetStatusGuidByCode(thisTs.Ticket.dpa_approvalstatuscode)

          let TicketNo = await thisTs.Api.post("crmservice", "approvalTicket", thisTs.Ticket);
          if (thisTs.Ticket.dpa_approvalstatuscode == '03') {
            await thisTs.InformStatus(thisTs.Ticket.dpa_approvalstatuscode);
          }
          thisTs.Util.SuccessDialog("บันทึกสำเร็จ");

          await thisTs.BackToHome(true);
        });
      }
      else {
        let Remark = $("#Remark").val();
        if (Remark == null || Remark == "") {
          this.Util.WarningDialog("กรุณาระบุหมายเหตุ");
          return;
        }
        await this.Util.ConfirmDialog("ยืนยันไม่อนุมัติรายการ?");
        $("#btnMainConfirm").off('click');
        $("#btnMainConfirm").click(async function () {
          thisTs.Ticket.dpa_remark = Remark;
          //thisTs.Ticket.dpa_code = 6;
          thisTs.Ticket.dpa_approvalstatuscode = thisTs.Role.dpa_access_approve ? '05' : '06';
          thisTs.Ticket.attachfilelist = thisTs.FileList;
          thisTs.TotalFileSize = 0;
          thisTs.Ticket.attachfilelist.forEach((a: any) => {
            var Decoded = atob(a.documentbody);
            a.filesize = Decoded.length;
            thisTs.TotalFileSize += a.filesize;
            a.url = "";
          });
          thisTs.Ticket.dpa_attachsizing = thisTs.TotalFileSize;
          
          thisTs.Ticket.dpa_approvalstatusid = thisTs.GetStatusGuidByCode(thisTs.Ticket.dpa_approvalstatuscode)

          let TicketNo = await thisTs.Api.post("crmservice", "approvalTicket", thisTs.Ticket);
          await thisTs.InformStatus(thisTs.Ticket.dpa_approvalstatuscode);
          thisTs.Util.SuccessDialog("บันทึกสำเร็จ");
          await thisTs.BackToHome(true);
        });
      }
    }
    catch (err) {
      this.Util.ErrorDialog("บันทึกไม่สำเร็จ");
    }
  }

  async InformStatus(Status: string) {
    let Contact: any = await this.Api.get("crmservice", "contact", "contactid=" + this.Ticket.dpa_contactid);
    let MailObj: any = {
      //dpa_emailaddress: Contact[0].emailaddress1,
      dpa_name: this.Ticket.dpa_authorizedperson == null || this.Ticket.dpa_authorizedperson == "" ? this.Ticket.dpa_contactidname : this.Ticket.dpa_authorizedperson, 
      dpa_callby: 3, 
      dpa_agentbankuserid: localStorage.getItem("AgentBank_UserID"),
      contactid: this.Ticket.dpa_contactid
    };
    var MailContent = "เรียน คุณ" + MailObj.dpa_name + "<br /><br /> สถาบันคุ้มครองเงินฝากขอแจ้งสถานะการยืนยันตัวตนผ่าน Agent Bank " +
      (Status == "03" ? "ได้รับการอนุมัติเรียบร้อยแล้ว" : ((Status == "05" ? "ไม่ผ่านการอนุมัติ เนื่องจาก" : "ไม่ผ่านการตรวจสอบ เนื่องจาก") + this.Ticket.dpa_remark)) + "<br />" +
      "ท่านสามารถเข้าตรวจสอบข้อมูลสถานะการจ่ายคืนเงินฝากผ่านระบบออนไลน์ได้ที่ Link  <br /><br />" +
      "ขอแสดงความนับถือ <br />" +
      "สถาบันคุ้มครองเงินฝาก <br />" +
      "อาคารเอสเจ อินฟินิท วัน บิสซิเนสคอมเพล็กซ์ <br />" +
      "ชั้น 25-27 เลขที่ 349 ถนนวิภาวดีรังสิต <br />" +
      "แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900 <br />" +
      "โทร : 02-272-0300";
    MailObj.dpa_description = MailContent;
    let Res = await this.Api.postPortal("crm", "informStatus", MailObj);
    return Res;
  }

  async SubmitOTP() {
    if ($("#OTP").val() == "") {
      this.Util.WarningDialog("กรุณาระบุรหัส OTP");
      return;
    }

    let ParamObj: any = {
      OTP: $("#OTP").val(), 
      RefCode: this.OTPRefCode, 
      MobileNo: this.Contact.telephone1
    };
    let Res: any = await this.Api.postPortal("Crm", "VerifyOTP", ParamObj);
    if (Res.IsValid == null || Res.IsValid == undefined) {
      this.Util.WarningDialog("เกิดข้อผิดพลาดระหว่างตรวจสอบ OTP กรุณาติดต่อผู้ดูแลระบบ");
      return;
    }
    if (Res.IsValid == false) {
      this.Util.WarningDialog("รหัส OTP ไม่ถูกต้อง");
      return;
    }

    $("#divOTP").addClass("hidden");
    $("#divDocList").removeAttr("disabled");
    $("#divUpload").removeAttr("disabled");
    $("#divFiles").removeAttr("disabled");
    $("#divRemark").removeAttr("disabled");
    $("#divButtons").removeAttr("disabled");
  }

  async CancelSearch() {
    $("#SearchFirstName").val("");
    $("#SearchLastName").val("");
    $("#SearchIdCard").val("");
    $("#SearchPassport").val("");
    this.CreateTable1();
  }

  async RecreateTicket() {
    if (!this.Editable) {
      this.Editable = true;
      $("#divButtonRecreate").removeClass("hidden");
      $("#btnRecreate").html("ส่งข้อมูล");
      $("#divDocList").removeAttr("disabled");
      $("#divUpload").removeClass("hidden");
      $("#divUpload").removeAttr("disabled");
      $("#divFiles").removeAttr("disabled");
      $("#divRemark").removeAttr("disabled");
      $("#Remark").val("");
      this.FileList = [];
      this.Ticket.attachfilelist = [];
      this.Ticket.dpa_documentchecklist = "";
      let thisTs = this;
      this.CreateDocumentList();
      $('.docCheck').on("change", function (e: any) {
        thisTs.SelectDocument(e.target);
      });
      this.CreateTableFile();
      return;
    }

    if (this.FileList.length == 0) {
      this.Util.WarningDialog("กรุณาอัปโหลดไฟล์เอกสาร");
      return;
    }

    var DocGroup: any;
    if (this.Type == CustomerType.Company) {
      DocGroup = this.CompanyTypeList.filter((a: any) => a.dpa_companytypeid == this.Ticket.dpa_companytypeid)[0].dpa_documentgrouplist;
    }
    else {
      DocGroup = this.PersonTypeList.filter((a: any) => a.dpa_personaltypeid == this.Ticket.dpa_personaltypeid)[0].dpa_documentgrouplist;
    }

    let IsValid: any = await this.Util.ValidateSelectedDocument(this.DocumentList, DocGroup);
    if (!IsValid) {
      return;
    }

    this.Util.ShowWaiting(true);
    this.Ticket.dpa_approvalstatuscode = '02';
    this.Ticket.dpa_approvalticketid = null;
    this.Ticket.dpa_name = null;
    this.Ticket.dpa_originalsource = 2;
    this.Ticket.dpa_remark = $("#Remark").val();
    this.Ticket.dpa_submitdate = new Date();
    var DocList = "";
    this.DocumentList.forEach((a: any) => {
      DocList += (DocList == "" ? "" : "|") + a.dpa_documentid;
    });
    this.Ticket.attachfilelist = this.FileList;
    this.Ticket.dpa_documentchecklist = DocList;
    this.TotalFileSize = 0;
    this.Ticket.attachfilelist.forEach((a: any) => {
      var Decoded = atob(a.documentbody);
      a.filesize = Decoded.length;
      this.TotalFileSize += a.filesize;
      a.url = "";
    });
    this.Ticket.dpa_attachsizing = this.TotalFileSize;
    try {
      this.Ticket.dpa_approvalstatusid = this.GetStatusGuidByCode(this.Ticket.dpa_approvalstatuscode)

      let Res: any = await this.Api.post('crmservice', 'approvalticket', this.Ticket);
      this.Util.ShowWaiting(false);
      if (Res.dpa_name != null && Res.dpa_name != "") {
        this.Util.SuccessDialog("บันทึกข้อมูลสำเร็จ เลขรับเรื่องคือ " + Res.dpa_name);
        await this.BackToHome(true);
      }
      else {
        this.Util.WarningDialog("บันทึกข้อมูลไม่สำเร็จ");
      }
    }
    catch (err) {
      this.Util.ShowWaiting(false);
      this.Util.WarningDialog("บันทึกข้อมูลไม่สำเร็จ");
    }
  }

  async RequestOTP() {
    try {
      this.Contact = await this.Api.get("crmservice", "contact", "contactid=" + this.Ticket.dpa_contactid);
      this.Contact = this.Contact[0];
      let ParamObj: any = {
        MobileNo: this.Contact.telephone1
      };
      let Res: any = await this.Api.postPortal("Crm", "RequestOTP", ParamObj);
      if (Res.otpNo != null && Res.otpNo != undefined) {
        this.OTPRefCode = Res.RefCode;
        console.log(Res.otpNo);
        $("#OTPRefCode").html(Res.RefCode); 
        let Msg = "รหัสตรวจสอบการยืนยันตัวตนผ่านตัวแทนธนาคารของคุณคือ : "
        Msg += Res.otpNo + " "
        Msg += "(RefCode : " +Res.RefCode  
        Msg += "(รหัสมีอายุ " + Res.expInMinute + " นาที) อย่าเปิดเผยรหัสกับผู้อื่น"   
        ParamObj = {
          dpa_phoneno: this.Contact.telephone1,
          dpa_description: Msg
        };
        let SmsRes: any = this.Api.post("crmservice", "sendSms", ParamObj);

        $("#btnSubmitOTP").removeAttr("disabled");
        if (Res.expInMinute == undefined || Res.expInMinute == null) {
          this.TotalTime = 300;
        }
        else {
          this.TotalTime = Res.expInMinute * 60;
        }
        this.ElapseTime = 0;
        if (this.SubScr != undefined) {
          this.SubScr.unsubscribe();
        }
        this.SubScr = timer(0, 1000).subscribe(() => this.CountDownOTP());
        this.WaitTime = 60;
        $("#btnRequestOTP").attr("disabled", "disabled");
        if (this.SubScr2 != undefined) {
          this.SubScr2.unsubscribe();
        }
        this.SubScr2 = timer(0, 1000).subscribe(() => this.CountDownWaitTime());
      }
      else {
        $("#btnSubmitOTP").attr("disabled", "disabled");
        this.Util.ShowWaiting(false);
        this.Util.WarningDialog("เกิดข้อผิดพลาดในการขอรหัส OTP กรุณาติดต่อผู้ดูแลระบบ");
      }
    }
    catch (err) {
      $("#btnSubmitOTP").attr("disabled", "disabled");
      this.Util.ShowWaiting(false);
      this.Util.WarningDialog("เกิดข้อผิดพลาดในการขอรหัส OTP กรุณาติดต่อผู้ดูแลระบบ");
    }
  }

  CountDownOTP() {
    if (this.ElapseTime == 0 && this.TotalTime == 0) {
      this.SubScr.unsubscribe();
      return;
    }
    if (this.ElapseTime == this.TotalTime) {
      this.SubScr.unsubscribe();
      $("#btnSubmitOTP").attr("disabled", "disabled");
      $("#btnSubmitOTP").html("ยืนยัน");
      this.ElapseTime = 0;
      return;
    }
    
    this.ElapseTime++;
    let RemainingSecs = this.TotalTime - this.ElapseTime;
    let RemainingMins = (RemainingSecs - (RemainingSecs % 60)) / 60;
    RemainingSecs = RemainingSecs % 60;
    $("#btnSubmitOTP").html("ยืนยัน " + RemainingMins + ":" + (RemainingSecs < 10 ? "0" : "") + RemainingSecs);
  }

  CountDownWaitTime() {
    if (this.WaitTime == 0) {
      $("#btnRequestOTP").html("ขอรหัสอีกครั้ง");
      $("#btnRequestOTP").removeAttr("disabled");
      this.SubScr2.unsubscribe();
      return;
    }
    this.WaitTime--;
    $("#btnRequestOTP").html("ขอรหัสอีกครั้ง " + this.WaitTime);
  }

  GetApprovalName(code: string){
    let status: any = this.masterStatus.filter((s: any) => {
      return s.dpa_code == code
    })
    if(status != null && status.length > 0){
      return status[0].dpa_name
    }
    else{
      return ""
    }
  }

  GetStatusGuidByCode(code: string){
    let found: any = this.masterStatus.filter((s:any) => {
      return s.dpa_code == code
    })

    if(found != null && found.length > 0){
      return found[0].dpa_approvalstatusid
    }
    else{
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/ticket/ticket-list/ticket-list.component.ts